import { createContext, useContext, useState } from "react";

const dict = {
  fr: {
    nav: { story: "Notre Table", menu: "La Carte", gallery: "Galerie", reservation: "Réservation", info: "Infos & Accès", cta: "Réserver une table" },
    hero: {
      overline: "Cuisine camerounaise · Anderlecht, Bruxelles",
      line1: "Les Retrouvailles",
      line2: "de la Douce",
      slogan: "La table de causerie de la diaspora — les saveurs du Cameroun au cœur de Bruxelles.",
      cta1: "Réserver une table",
      cta2: "Découvrir la carte",
      badge: "5,0 sur Google",
      partner: "Livraison repas & VTC avec notre partenaire Noldgo",
      scroll: "Faites défiler",
    },
    marquee: ["Ndolé Royal", "Poulet DG", "Eru & Waterfufu", "Poisson Braisé Akit", "Plantains Mûrs Grillés", "Bière « 33 » Export", "Jus de Bissap"],
    manifesto: {
      overline: "Notre histoire",
      title: "Un lieu, trois promesses",
      chapters: [
        {
          n: "01",
          title: "Le lieu de rencontre",
          text: "Au cœur d'Anderlecht, à deux pas du métro Clemenceau, Les Retrouvailles de la Douce est la table de causerie de la diaspora africaine à Bruxelles. On s'y retrouve entre amis, on y refait le monde, on y célèbre les petites et les grandes nouvelles.",
        },
        {
          n: "02",
          title: "L'art culinaire du Cameroun",
          text: "Du ndolé royal au poulet DG, de l'eru au poisson braisé Akit : chaque plat est cuisiné comme à Douala et Yaoundé — mijoté longuement, relevé avec cœur, servi bien chaud en moins de dix minutes.",
        },
        {
          n: "03",
          title: "Convivialité & causeries",
          text: "Boissons bien fraîches, prix doux, ambiance chaleureuse jusqu'au bout de la nuit — 4h du matin le week-end. Ici, chacun repart avec un peu de la douceur des retrouvailles.",
        },
      ],
    },
    menu: {
      overline: "La Carte",
      title: "Les saveurs du Cameroun",
      subtitle: "Prix doux, de 10 à 20 € · Livraison & à emporter",
      cats: { all: "Tout", entrees: "Entrées", plats: "Plats signatures", sides: "Accompagnements", drinks: "Desserts & Boissons" },
      spicy: "Relevé",
      signature: "Signature",
      takeaway: "Commander · Noldgo",
      takeawayNote: "Prix de commande incluant les 25% de commission Noldgo",
      partner: "Livraison & VTC assurées par notre partenaire",
    },
    order: {
      title: "Commander à emporter",
      qty: "Quantité",
      name: "Nom complet",
      phone: "Téléphone",
      pickup: "Heure de retrait",
      notes: "Message (optionnel)",
      total: "Total (commission Noldgo 25% incluse)",
      submit: "Envoyer la commande",
      sending: "Envoi en cours…",
      success: "Commande envoyée ! Nous vous appelons pour confirmer.",
      error: "Une erreur est survenue. Réessayez ou appelez-nous.",
      viaNoldgo: "ou commander via la vitrine Noldgo",
    },
    gallery: { overline: "Galerie", title: "L'ambiance des Retrouvailles" },
    reservation: {
      overline: "Réservation",
      title: "Réservez votre table",
      subtitle: "Confirmation par téléphone — ou appelez-nous directement au +32 470 31 35 54.",
      name: "Nom complet",
      phone: "Téléphone",
      email: "Email (optionnel)",
      date: "Date",
      time: "Heure",
      guests: "Convives",
      seating: "Préférence de table",
      seatingCauserie: "Table de causerie",
      seatingInterieur: "Intérieur cosy",
      notes: "Message (optionnel)",
      submit: "Confirmer la réservation",
      sending: "Envoi en cours…",
      success: "Réservation envoyée ! Nous confirmons par téléphone.",
      error: "Une erreur est survenue. Réessayez ou appelez-nous.",
      guest: "personne",
      guestsPlural: "personnes",
    },
    info: {
      overline: "Infos & Accès",
      title: "Nous trouver",
      addressLabel: "Adresse",
      address1: "Av. Clemenceau 34 — Rez-de-chaussée « Le Sud »",
      address2: "1070 Anderlecht, Bruxelles",
      metro: "Métro Clemenceau · Lignes 2 & 6",
      phoneLabel: "Téléphone",
      hours: "Heures d'ouverture",
      days: ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"],
      today: "Aujourd'hui",
      features: ["Livraison via Noldgo", "À emporter", "Atmosphère chaleureuse"],
      partnerText: "Partenaire officiel — livraison de repas & VTC en Belgique",
      map: "Ouvrir dans Google Maps",
    },
    footer: {
      tagline: "La douceur de se retrouver.",
      admin: "Espace Admin",
      partner: "Partenaire livraison & VTC :",
      rights: "Tous droits réservés.",
    },
  },
  nl: {
    nav: { story: "Onze Tafel", menu: "De Kaart", gallery: "Galerij", reservation: "Reservatie", info: "Info & Route", cta: "Reserveer een tafel" },
    hero: {
      overline: "Kameroense keuken · Anderlecht, Brussel",
      line1: "Les Retrouvailles",
      line2: "de la Douce",
      slogan: "De gesprekstafel van de diaspora — de smaken van Kameroen in het hart van Brussel.",
      cta1: "Reserveer een tafel",
      cta2: "Ontdek de kaart",
      badge: "5,0 op Google",
      partner: "Maaltijdlevering & VTC met onze partner Noldgo",
      scroll: "Scroll verder",
    },
    marquee: ["Ndolé Royal", "Poulet DG", "Eru & Waterfufu", "Poisson Braisé Akit", "Plantains Mûrs Grillés", "Bière « 33 » Export", "Bissapsap"],
    manifesto: {
      overline: "Ons verhaal",
      title: "Eén plek, drie beloften",
      chapters: [
        {
          n: "01",
          title: "De ontmoetingsplek",
          text: "In het hart van Anderlecht, op steenworp van metro Clemenceau, is Les Retrouvailles de la Douce dé gesprekstafel van de Afrikaanse diaspora in Brussel. Hier kom je samen met vrienden, put je de wereld over en vier je het leven.",
        },
        {
          n: "02",
          title: "De kookkunst van Kameroen",
          text: "Van koninklijke ndolé tot kip DG, van eru tot gebraaide vis Akit: elk gerecht wordt gekookt zoals in Douala en Yaoundé — langzaam gestoofd, met liefde gekruid en binnen tien minuten warm geserveerd.",
        },
        {
          n: "03",
          title: "Gezelligheid & gesprekken",
          text: "IJskoude drankjes, zachte prijzen en een warme sfeer tot diep in de nacht — tot 4 uur in het weekend. Hier vertrek je altijd met een stukje zoetheid van het weerzien.",
        },
      ],
    },
    menu: {
      overline: "De Kaart",
      title: "De smaken van Kameroen",
      subtitle: "Zachte prijzen, van 10 tot 20 € · Levering & afhaal",
      cats: { all: "Alles", entrees: "Voorgerechten", plats: "Signature gerechten", sides: "Bijgerechten", drinks: "Desserts & Dranken" },
      spicy: "Pittig",
      signature: "Signature",
      takeaway: "Bestellen · Noldgo",
      takeawayNote: "Bestelprijzen inclusief 25% Noldgo-commissie",
      partner: "Levering & VTC via onze partner",
    },
    order: {
      title: "Afhaal bestellen",
      qty: "Aantal",
      name: "Volledige naam",
      phone: "Telefoon",
      pickup: "Afhaaluur",
      notes: "Bericht (optioneel)",
      total: "Totaal (25% Noldgo-commissie inbegrepen)",
      submit: "Verstuur bestelling",
      sending: "Verzenden…",
      success: "Bestelling verzonden! Wij bellen u ter bevestiging.",
      error: "Er ging iets mis. Probeer opnieuw of bel ons.",
      viaNoldgo: "of bestel via de Noldgo-winkel",
    },
    gallery: { overline: "Galerij", title: "De sfeer van de Retrouvailles" },
    reservation: {
      overline: "Reservatie",
      title: "Reserveer uw tafel",
      subtitle: "Bevestiging per telefoon — of bel ons rechtstreeks op +32 470 31 35 54.",
      name: "Volledige naam",
      phone: "Telefoon",
      email: "E-mail (optioneel)",
      date: "Datum",
      time: "Uur",
      guests: "Gasten",
      seating: "Tafelvoorkeur",
      seatingCauserie: "Gesprekstafel",
      seatingInterieur: "Gezellig binnen",
      notes: "Bericht (optioneel)",
      submit: "Bevestig reservatie",
      sending: "Verzenden…",
      success: "Reservatie verzonden! Wij bevestigen telefonisch.",
      error: "Er ging iets mis. Probeer opnieuw of bel ons.",
      guest: "persoon",
      guestsPlural: "personen",
    },
    info: {
      overline: "Info & Route",
      title: "Vind ons",
      addressLabel: "Adres",
      address1: "Clemenceaulaan 34 — gelijkvloers « Le Sud »",
      address2: "1070 Anderlecht, Brussel",
      metro: "Metro Clemenceau · Lijnen 2 & 6",
      phoneLabel: "Telefoon",
      hours: "Openingsuren",
      days: ["Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag", "Zondag"],
      today: "Vandaag",
      features: ["Levering via Noldgo", "Afhaal", "Warme sfeer"],
      partnerText: "Officiële partner — maaltijdlevering & VTC in België",
      map: "Open in Google Maps",
    },
    footer: {
      tagline: "De zoetheid van het weerzien.",
      admin: "Beheer",
      partner: "Partner levering & VTC:",
      rights: "Alle rechten voorbehouden.",
    },
  },
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState("fr");
  return <LangContext.Provider value={{ lang, setLang, t: dict[lang] }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -64 });
  else el.scrollIntoView({ behavior: "smooth" });
};
